export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: "NOMBRE DEL SUBCONTRATISTA",
                    type: 'text',
                    key: 'name',
                },
                {
                    title: "DIRECCIÓN DEL SUBCONTRATISTA",
                    type: 'text',
                    key: 'address',
                },
                {
                    title: 'ALCANCE DE LAS ACTIVIDADES DESARROLLADAS POR EL SUBCONTRATISTA',
                    type: 'text',
                    key: 'scope',
                },
                {
                    title: "INFORMACIÓN DE CÓMO SE EVALUÓ AL SUBCONTRATISTA",
                    type: 'text',
                    key: 'evaluation_information',
                },
                {
                    title: "DISPONE DE ACREDITACIÓN",
                    type: 'custom-html',
                    key: 'has_accreditation',
                    modifier: (value) => {
                        return value ? 'SI' : 'NO';
                    }
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}